import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import useLocalStorageState from 'use-local-storage-state';
import { PurchaseIcon } from "../pages/PurchaseIcon"
import "../Utils/assets/css/aside.css";
const Aside = ({ isOpen, isHovered, setIsHovered }) => {
  const [openDropdown, setOpenDropdown] = useState(null)
  const location = useLocation();
  const isActiveRoute = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };
  const navigate = useNavigate()
  const [customer, setcustomer] = useLocalStorageState("customer")
  const toggleDropdown = (menuName) => {
    setOpenDropdown(openDropdown === menuName ? null : menuName)
  }
  const permissions = customer.customer_details?.permission
  const user_type = Number(customer.customer_details?.user_type)
  const isQuotation = Boolean(permissions?.find(c => c.module_name.toLowerCase() === "quotation"))
  const isPurchaseOrder = Boolean(permissions?.find(c => c.module_name.toLowerCase()?.toLowerCase()?.split(" ")?.join("_") === "purchase_order"))
  const isReport = Boolean(permissions?.find(c => c.module_name.toLowerCase() === "reports"))
  const isCalendar = Boolean(permissions?.find(c => c.module_name.toLowerCase() === "calendar"))
  const isProject = Boolean(permissions?.find(c => c.module_name.toLowerCase() === "project"))
  const isSales = Boolean(permissions?.find(c => c.module_name.toLowerCase()?.toLowerCase()?.split(" ")?.join("_") === "sales_order"))

  const dashboardPermission = permissions?.filter(c => c.module_name === "dashboard")
  const projectView = user_type !== 1 ? Boolean(Number(dashboardPermission?.filter(c => c.feature_name === "project")[0]?.view)) : true
  const inboxView = user_type !== 1 ? Boolean(Number(dashboardPermission?.filter(c => c.feature_name === "inbox")[0]?.view)) : true

  const navItems = [
    {
      path: "/dashboard",
      label: "Dashboard",
      exact: true,
      icon: `bi bi-globe`,
      canView: true
    },
    { path: "/ProjectDashboard", label: "Projects", icon: `bi bi-layers`, canView: projectView },
    { path: "/testing", label: "Inbox", icon: `bi bi-inboxes`, canView: inboxView },
  ]
  const campItems = [
    {
      path: "/email",
      label: "Email Campaign",
      // exact: true,
      icon: `bi bi-envelope-open-fill`,
    },
    { path: "/whatsapp", label: "Whatsapp Campaign", icon: `bi bi-whatsapp` },
    { path: "/sms", label: "Sms Campaign", icon: `bi bi-layers` },
  ]

  const toolItems = [
    {
      path: "/gst_calculator",
      label: "GST Calculator",
      // exact: true,
      icon: `bi bi-calculator`,
    },
    { path: "/notepad", label: "Notepad", icon: `bi bi-card-checklist` },
  ]

  useEffect(() => {
    const menuItems = document.querySelectorAll(".side-menu__item")
    const slide = document.querySelectorAll(".slide")

    if (isOpen) {
      setIsHovered(false)
      menuItems.forEach((item) => item.classList.add("sidebarOpen"))
      slide.forEach((item) => item.classList.add("sidebarOpen"))
    } else {
      setIsHovered(true)
      menuItems.forEach((item) => item.classList.remove("sidebarOpen"))
      slide.forEach((item) => item.classList.remove("sidebarOpen"))
    }
  }, [isOpen])

  const dashboardActiveRoute =
    isActiveRoute("/dashboard") ||
    isActiveRoute("/ProjectDashboard") ||
    isActiveRoute("/testing");
  return (
    <>
      <aside
        className="app-sidebar sticky"
        id="sidebar"
        style={{
          width: isOpen ? "3.6rem" : "15rem",
          height: "100vh",
          transition: "width 0.3s ease",
          backgroundColor: "#fff", // Ensure background exists
        }}
      >
        <link
          rel="shortcut icon"
          type="image/x-icon"
          href="upload/setting/p28.png"
        />
        <div
          className="main-sidebar border-right"
          id="sidebar-scroll"
          style={{
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarColor: "transparent transparent",
          }}
        >
          {/* Custom Scrollbar Styling (Optional - hides scrollbar but keeps functionality) */}
          <style jsx>{`
            .main-sidebar::-webkit-scrollbar {
              width: 5px;
            }
            .main-sidebar::-webkit-scrollbar-track {
              background: transparent;
            }
            .main-sidebar::-webkit-scrollbar-thumb {
              background: #ccc;
              border-radius: 4px;
            }
            .main-sidebar::-webkit-scrollbar-thumb:hover {
              background: #7a3a5e;
            }
          `}</style>

          <div
            className="simplebar-content"
            style={{ padding: "7.5px 0px 7.5px" }}
          >
            <nav className="main-menu-container nav nav-pills flex-column sub-open">
              {/* Slide Left Icon */}
              <div className="slide-left d-none" id="slide-left">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#7b8191"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
                </svg>
              </div>
              <ul style={{ position: "relative" }}>
                {/* Dashboard Item */}
                <li className="slide"
                  style={{
                    position: "relative",
                  }}
                >
                  <Tooltip placement="right-end" arrow
                    title={navItems.map((c, index) => (
                      <div
                        key={index}
                        className="news-item"
                        onClick={() => {
                          if (c.label?.toLowerCase()?.split(" ")?.join("_") === "projects" && (!isProject || !c.canView)) {
                            if (!isProject) {
                              toast.warning("Upgrade your plan to see projects!")
                            } else {
                              toast.warning("You are not authorized to view Projects!")
                            }
                            return
                          } else if (!c.canView) {
                            toast.warning("You are not authorized for this action!")
                            return
                          }
                          navigate(c.path)
                        }
                        }
                      >
                        <p className="news-link" style={{ backgroundColor: isActiveRoute(c.path) ? "white" : "", color: isActiveRoute(c.path) ? "black" : "" }}>
                          <i
                            className={`${c.icon}`}
                            style={{ marginRight: "10px" }}
                          ></i>
                          {c.label}
                        </p>
                        <hr style={{ margin: "8px" }} />
                      </div>
                    ))}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                          borderRadius: "7px",
                          padding: "21px 10px 8px 10px",
                          boxShadow: "0px 0px 15px #574d4d54",
                          height: "12rem",
                          width: "200px"
                        },
                      },

                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link className="side-menu__item selectedModul"
                      style={{
                        backgroundColor: dashboardActiveRoute ? "#7a3a5e" : "#fff",
                      }}>
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: dashboardActiveRoute ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="bi bi-grid-1x2-fill"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>

                  <style jsx>{`

                    .slide:hover .news {
                      display: block;
                    }

                    .news-item {
                      cursor: pointer;
                    }

                    .news-link {
                      margin: 0;
                      padding: 6px 10px;
                      color: #fff;
                      line-height: 1.5rem;
                      border-radius: 5px;
                      transition: background 0.2s, color 0.2s;
                    }

                    .news-link:hover {
                      background: #fff;
                      color: #000;
                      font-weight: 600;
                    }

                    .news hr {
                      margin: 5px 0;
                      border: none;
                      border-top: 1px solid #eee;
                    }
                  `}</style>

                </li>
                {/* Leads */}
                <li className="slide">
                  <Tooltip
                    title="Leads"
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link to="/leads"
                      style={{
                        backgroundColor: isActiveRoute("/leads") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/leads") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="bx bxs-user"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Contacts */}
                <li className="slide">
                  <Tooltip
                    title="Contacts"
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link to="/contacts"
                      style={{
                        backgroundColor: isActiveRoute("/contacts") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/contacts") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="bi bi-person-badge-fill"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Company */}
                <li className="slide">
                  <Tooltip
                    title="Company"
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link to="/company" style={{
                      backgroundColor: isActiveRoute("/company") ? "#7a3a5e" : "#fff",
                    }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/company") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="bx bxs-business"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Deals */}
                <li className="slide">
                  <Tooltip
                    title="Deals"
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link to="/deals" style={{
                      backgroundColor: isActiveRoute("/deals") ? "#7a3a5e" : "#fff",
                    }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/deals") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="fa-solid fa-sack-dollar"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Quotations */}
                <li className="slide">
                  <Tooltip
                    title="Quotations"
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link to="/quotations" onClick={(e) => {
                      if (!isQuotation) {
                        e.preventDefault()
                        toast.warning("Upgrade your plan to see quoatations!")
                        return
                      }
                    }} style={{
                      backgroundColor: isActiveRoute("/quotations") ? "#7a3a5e" : "#fff",
                    }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/quotations") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="fa-solid fa-clipboard-list"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Purchase Order */}
                <li className="slide">
                  <Tooltip
                    title="Purchase"
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link to="/purchaseOrder" onClick={(e) => {
                      if (!isPurchaseOrder) {
                        e.preventDefault()
                        toast.warning("Upgrade your plan to see Purchase Order!")
                        return
                      }
                    }} style={{
                      backgroundColor: isActiveRoute("/purchaseOrder") ? "#7a3a5e" : "#fff",
                    }}
                      className="side-menu__item">
                      <span
                        className="iconOuter hoveredSvg iconSpan"
                        style={{
                          color: isActiveRoute("/purchaseOrder") ? "white" : "#536484",
                        }}
                      >
                        <PurchaseIcon
                          className="purchase-icon"
                          style={{
                            color: "inherit",
                          }}
                        />
                      </span>

                      <style jsx>{`
                        .hoveredSvg:hover {
                          color: white !important;
                        }
                      `}</style>
                    </Link>
                  </Tooltip>
                </li>

                {/* Sales Order */}
                <li className="slide">
                  <Tooltip
                    title="Sales"
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                    arrow
                  >
                    <Link to="/salesorder"
                      onClick={(e) => {
                        if (!isSales) {
                          e.preventDefault()
                          toast.warning("Upgrade your plan to see Sales Order!")
                          return
                        }
                      }}

                      style={{
                        backgroundColor: isActiveRoute("/salesorder") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/salesorder") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="bi bi-clipboard2-pulse-fill  "
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Projects */}
                <li className="slide">
                  <Tooltip
                    title="Projects"
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                    arrow
                  >
                    <Link to="/projects"
                      onClick={(e) => {
                        if (!isProject) {
                          e.preventDefault()
                          toast.warning("Upgrade your plan to see Projects!")
                          return
                        }
                      }}
                      style={{
                        backgroundColor: isActiveRoute("/projects") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i style={{
                          color: isActiveRoute("/projects") ? "white" : "",
                          width: "1.15rem",
                          height: "1.15rem",
                          borderRadius: "0.5rem",
                          marginInlineEnd: "0.625rem",
                          textAlign: "center",
                          margin: "auto",
                          fontSize: "19px"
                        }}
                          className="bi bi-clipboard-data-fill "></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* workflow */}
                <li className="slide">
                  <Tooltip
                    title="Workflow"
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                    arrow
                  >
                    <Link to="/workflow"
                      onClick={(e) => {
                        if (!isProject) {
                          e.preventDefault()
                          toast.warning("Upgrade your plan to see Workflow!")
                          return
                        }
                      }}
                      style={{
                        backgroundColor: isActiveRoute("/workflow") || isActiveRoute("/roundrobin") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/workflow") || isActiveRoute("/roundrobin") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="fa-solid fa-diagram-project"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Calender */}
                <li className="slide">
                  <Tooltip
                    title="Calender"
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                    arrow
                  >
                    <Link to="/calender"
                      onClick={(e) => {
                        if (!isCalendar) {
                          e.preventDefault()
                          toast.warning("Upgrade your plan to see Calendar!")
                          return
                        }
                      }}
                      style={{
                        backgroundColor: isActiveRoute("/calender") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/calender") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="fa-solid fa-calendar-days"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Reports */}
                <li className="slide">
                  <Tooltip
                    title="Reports"
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link to="/reports"
                      onClick={(e) => {
                        if (!isReport) {
                          e.preventDefault()
                          toast.warning("Upgrade your plan to see Reports!")
                          return
                        }
                      }}
                      style={{
                        backgroundColor: isActiveRoute("/reports") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/reports") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="fa-solid fa-chart-pie"
                        ></i>
                      </span>
                    </Link>
                  </Tooltip>
                </li>

                {/* Tools Dropdown */}
                <li className="slide has-sub">
                  <Tooltip placement="right-end" arrow
                    title={toolItems.map((c, index) => (
                      <div
                        key={index}
                        className="tool-item"
                        onClick={() => navigate(c.path)}
                      >
                        <p className="tool-link">
                          <i
                            className={`${c.icon}`}
                            style={{ marginRight: "10px" }}
                          ></i>
                          {c.label}
                        </p>
                        <hr style={{ margin: "8px" }} />
                      </div>
                    ))}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                          borderRadius: "7px",
                          padding: "21px 10px 8px 10px",
                          boxShadow: "0px 0px 15px #574d4d54",
                          height: "8rem",
                          width: "200px"
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("tools")}
                      className="side-menu__item"
                    >
                      <span className="iconOuter iconSpan">
                        <i className="fa-solid fa-screwdriver-wrench side-menu__icon"></i>
                      </span>
                      <span
                        className="side-menu__label"
                        style={{ marginLeft: "-1.3px" }}
                      >
                        Tools
                      </span>
                      <i className="fe fe-chevron-right side-menu__angle"></i>
                    </Link>
                  </Tooltip>
                  <style jsx>{`
                    .tool-item {
                      cursor: pointer;
                    }

                    .tool-link {
                      margin: 0;
                      padding: 6px 10px;
                      color: #fff;
                      line-height: 1.5rem;
                      border-radius: 5px;
                      transition: background 0.2s, color 0.2s;
                    }

                    .tool-link:hover {
                      background: #fff;
                      color: #000;
                      font-weight: 600;
                    }

                    .tool hr {
                      margin: 5px 0;
                      border: none;
                      border-top: 1px solid #eee;
                    }
                  `}</style>
                </li>
                <li className="slide has-sub">
                  <Tooltip placement="right-end" arrow
                    title={campItems.map((c, index) => (
                      <div
                        key={index}
                        className="campaign-item"
                        onClick={() => navigate(c.path)}
                      >
                        <p className="campaign-link">
                          <i
                            className={`${c.icon}`}
                            style={{ marginRight: "10px" }}
                          ></i>
                          {c.label}
                        </p>
                        <hr style={{ margin: "8px" }} />
                      </div>
                    ))}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          fontSize: "0.8rem",
                          backgroundColor: "#7a3a5e",
                          color: "white",
                          borderRadius: "7px",
                          padding: "21px 10px 8px 10px",
                          boxShadow: "0px 0px 15px #574d4d54",
                          height: "12rem",
                          width: "200px"
                        },
                      },
                      arrow: { sx: { color: "#7a3a5e" } },
                    }}
                  >
                    <Link
                      onClick={() => toggleDropdown("campaigning")}
                      className="side-menu__item"
                    >
                      <span className="iconOuter iconSpan">
                        <i className="fa-solid fa-comment-nodes side-menu__icon"></i>
                      </span>
                      <span
                        className="side-menu__label"
                        style={{ marginLeft: "-1.3px" }}
                      >
                        Campaigning
                      </span>
                      <i className="fe fe-chevron-right side-menu__angle"></i>
                    </Link>
                  </Tooltip>
                  <style jsx>{`
                    .campaign-item {
                      cursor: pointer;
                    }

                    .campaign-link {
                      margin: 0;
                      padding: 6px 10px;
                      color: #fff;
                      line-height: 1.5rem;
                      border-radius: 5px;
                      transition: background 0.2s, color 0.2s;
                      white-space : nowrap;
                    }

                    .campaign-link:hover {
                      background: #fff;
                      color: #000;
                      font-weight: 600;
                    }

                    .campaign hr {
                      margin: 5px 0;
                      border: none;
                      border-top: 1px solid #eee;
                    }
                  `}</style>
                </li>

                {/* Settings Dropdown */}
                <li className="slide has-sub">
                  <Tooltip
                    title="Settings"
                    arrow
                    placement="right"
                    // Applied the same Purple Styling for consistency
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#7a3a5e",
                          color: "white",
                          fontSize: "0.8rem",
                          padding: "8px 12px", // Slightly smaller padding for text-only tooltips
                          boxShadow: "0px 0px 15px rgba(0,0,0,0.2)",
                          "& .MuiTooltip-arrow": { color: "#7a3a5e" },
                        },
                      },
                    }}
                  >
                    <Link to="/settings/masters" onClick={(e) => {
                      // if (!isReport) {
                      //   e.preventDefault()
                      //   toast.warning("Upgrade your plan to see Reports!")
                      //   return
                      // }
                    }}
                      style={{
                        backgroundColor: isActiveRoute("/settings") ? "#7a3a5e" : "#fff",
                      }}
                      className="side-menu__item">
                      <span className="iconOuter iconSpan">
                        <i
                          style={{
                            color: isActiveRoute("/settings") ? "white" : "",
                            width: "1.15rem",
                            height: "1.15rem",
                            borderRadius: "0.5rem",
                            marginInlineEnd: "0.625rem",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "19px"
                          }}
                          className="fa-solid fa-gear"
                        ></i>
                      </span>
                      <i className="fe fe-chevron-right side-menu__angle"></i>
                    </Link>
                  </Tooltip>
                </li>
              </ul>

              <div className="slide-right" id="slide-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#7b8191"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                </svg>
              </div>
            </nav>
          </div>
        </div>
      </aside>

      {/* Extra Sidebar Panel (Optional / Context dependent) */}
      <div className="bg-white newSidebar" id="newSidebar">
        {" "}
        <div className="headerName">Leads</div>
        <ul>
          <li>
            Add
            <span className="activeMenu ms-1"></span>
            <i class="fa-brands fa-plus icons"></i>
          </li>

          <li>
            Check
            <span className="activeMenu ms-1"></span>
            <span
              class="badge bg-default-success"
              style={{ marginLeft: "7px" }}
            >
              New
            </span>
          </li>

          <li>
            Edit
            <span className="activeMenu ms-1"></span>
            <i class="fa-solid fa-pencil icons"></i>
          </li>
        </ul>
        <div className="bottomMenu">
          <li>
            <i class="fa-brands fa-youtube"></i> User Guide
          </li>

          <li>
            <i class="bx bx-book-reader"></i> Knowledge Base
          </li>
        </div>
      </div>
    </>
  )
}

export default Aside
